module.exports = __webpack_public_path__ + "media/images/PimpsHSBC-7272397c9eaee3900bb28f6ee4326eee.jpg";